import { CustomState } from "@hardware/Store/Reducers";
import setFieldValue from "@hardware/Store/State/Survey/SetFieldValue";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    brandLocations = "brandLocations"
}

interface BrandLocationModel {
    fields: {
        brandLocation: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.brandLocations]: BrandLocationModel[];
    };
}

const mapStateToProps = (state: CustomState) => ({
    brandLocation: state.surveyForm.fieldValues["branch"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AvailableBrandLocationsStyles {
    brandLocationsSelect?: SelectPresentationProps;
}

export const availableBrandLocationsStyles: AvailableBrandLocationsStyles = {};

export const styles = availableBrandLocationsStyles;

const AvailableBrandLocations: React.FC<Props> = ({ fields, brandLocation, setFieldValue }) => {
    const { label, hintText, brandLocations } = fields;

    const brandLocationChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setFieldValue({ key: "branch", value: event.target.value });
    };

    return (
        <Select
            {...styles.brandLocationsSelect}
            label={label}
            value={brandLocation || ""}
            onChange={brandLocationChangeHandler}
        >
            <option value="">{hintText}</option>
            {brandLocations.map(brandLocation => (
                <option key={brandLocation.fields.brandLocation} value={brandLocation.fields.brandLocation}>
                    {brandLocation.fields.brandLocation}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AvailableBrandLocations),
    definition: {
        group: "Survey" as any,
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Brand Location",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Select Brand Location",
                isRequired: true,
            },
            {
                name: fields.brandLocations,
                displayName: "BrandLocations",
                editorTemplate: "ListField",
                defaultValue: [],
                getDisplay: (item: HasFields) => {
                    return item.fields.brandLocation;
                },
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "brandLocation",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
